export const createWeakMap = () => new WeakMap();
export const setInWeakMap = (m, k, v) => (m.set(k, v), v);
export const getFromWeakMap = (m, k) => m.get(k);
